<div class="vsf-pagination" *ngIf="totalResults > 0">
  <div class="vsf-pagination__toolbar">
    <div class="vsf-pagination__per-page-row">
      <span class="vsf-pagination__label">Show:</span>
      <div class="relative">
        <select
          class="vsf-pagination__select"
          aria-label="Items per page"
          [ngModel]="pageSize"
          (ngModelChange)="onPageSizeChange($event)"
        >
          <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
        </select>
      </div>
      <span class="vsf-pagination__label vsf-pagination__label--nowrap">per page</span>
    </div>

    <div class="vsf-pagination__page-info">
      Page <span class="vsf-pagination__page-info-strong">{{ currentPage }}</span>
      of <span class="vsf-pagination__page-info-strong">{{ totalPages }}</span>
      <span class="vsf-pagination__page-info-total">({{ totalResults | number }} total results)</span>
    </div>
  </div>

  <div class="vsf-pagination__controls-wrap">
    <div class="vsf-pagination__controls">
      <button
        type="button"
        (click)="goToFirst()"
        [disabled]="!canGoPrevious"
        class="vsf-pagination__nav-btn"
        aria-label="First Page"
        title="First Page"
      >
        <img src="assets/icons/chevrons-left.svg" alt="" class="w-4 h-4" />
        <span class="vsf-pagination__nav-label ml-1.5">First</span>
      </button>
      <button
        type="button"
        (click)="goToPrevious()"
        [disabled]="!canGoPrevious"
        class="vsf-pagination__nav-btn"
        aria-label="Previous Page"
        title="Previous Page"
      >
        <img src="assets/icons/chevron-left-outline.svg" alt="" class="w-4 h-4" />
        <span class="vsf-pagination__nav-label ml-1.5">Previous</span>
      </button>

      <div class="vsf-pagination__page-list">
        <button
          type="button"
          *ngFor="let page of pageNumbers"
          (click)="goToPage(page)"
          class="vsf-pagination__page-btn"
          [class.vsf-pagination__page-btn--current]="currentPage === page"
          [attr.aria-label]="'Go to page ' + page"
        >
          {{ page }}
        </button>
      </div>

      <button
        type="button"
        (click)="goToNext()"
        [disabled]="!canGoNext"
        class="vsf-pagination__nav-btn"
        aria-label="Next Page"
        title="Next Page"
      >
        <span class="vsf-pagination__nav-label mr-1.5">Next</span>
        <img src="assets/icons/chevron-right-outline.svg" alt="" class="w-4 h-4" />
      </button>
      <button
        type="button"
        (click)="goToLast()"
        [disabled]="!canGoNext"
        class="vsf-pagination__nav-btn"
        aria-label="Last Page"
        title="Last Page"
      >
        <span class="vsf-pagination__nav-label mr-1.5">Last</span>
        <img src="assets/icons/chevrons-right.svg" alt="" class="w-4 h-4" />
      </button>
    </div>
  </div>
</div>
